// Misc
import React, { Component, Fragment, createElement } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

// Atoms
import { NavLink } from 'react-router-dom'

// Components
import ButtonBase from '@material-ui/core/ButtonBase'
import Typography from '@material-ui/core/Typography'
import Logo from 'components/Layout/Logo'
import UserMenu from './UserMenu'

// Styles
const styles = theme => ({
  sidebar: {
    color: theme.palette.secondary.contrastText,
    backgroundColor: theme.palette.secondary.main,
    width: 180,
    position: 'fixed',
    left: 0,
    top: 0,
    bottom: 0,
  },
  logo: {
    minHeight: 100,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  main: {
    marginLeft: 180,
    padding: theme.spacing.unit * 5,
    paddingTop: (theme.spacing.unit * 5) - 7,
  },
  userMenu: {
    position: 'relative',
    float: 'right',
    zIndex: 2,
    marginTop: -30,
    marginLeft: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit,
  },
  children: {
    position: 'relative',
    zIndex: 1,
  },
  link: {
    textDecoration: 'none',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px`,
    borderLeft: `4px solid ${theme.palette.secondary.main}`,
    display: 'block',
    outline: 0,
    transition: theme.transitions.create(['border-color', 'background-color']),
    '&:hover': {
      backgroundColor: theme.palette.secondary.light,
      borderColor: theme.palette.secondary.light,
    },
  },
  linkInner: {
    whiteSpace: 'nowrap',
    flexWrap: 'nowrap',
    display: 'flex',
    alignItems: 'center',
    '& > svg': {
      marginRight: theme.spacing.unit,
    }
  },
  linkActive: {
    '&, &:hover': {
      borderColor: theme.palette.primary.main,
    }
  },
})

export default
@withStyles(styles)
class DesktopUserLayout extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    sidebarLinks: PropTypes.array.isRequired,
    userMenuLinks: PropTypes.array.isRequired,
    children: PropTypes.any,
  }

  renderLink = (link) => {
    const { classes } = this.props
    return (
      <ButtonBase
        component={NavLink}
        key={link.to}
        className={classes.link}
        activeClassName={classes.linkActive}
        to={link.to}
        tabIndex="-1"
      >
        <Typography variant="body1" color="inherit" className={classes.linkInner}>
          { createElement(link.icon) }
          { link.label }
        </Typography>
      </ButtonBase>
    )
  }

  render() {
    const { classes, sidebarLinks, userMenuLinks, children } = this.props
    return (
      <Fragment>
        <aside className={classes.sidebar}>
          <div className={classes.logo}>
            <Logo contrast />
          </div>
          <nav>
            { sidebarLinks.map(this.renderLink) }
          </nav>
        </aside>

        <main className={classes.main}>
          <div className={classes.userMenu}>
            <UserMenu links={userMenuLinks} />
          </div>
          <div className={classes.children}>
            { children }
          </div>
        </main>
      </Fragment>
    )
  }
}
